import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbilityConfig } from '../ability-config/ability-config';
import {PlatformLocation} from '@angular/common';
import {TokenService} from '../tokenService.service';

declare var $: any;

@Component({
	selector: 'app-case-practice-executive-list',
	templateUrl: './case-practice-executive-list.component.html',
	styleUrls: ['./case-practice-executive-list.component.css', ]
})
export class CaseExecutiveListComponent
  implements OnInit, AfterViewInit {
  practiceList: any;
  practiceId: any;
  learningPathId: any;
  practiceMetaId: any;
  momentList: any;
  exerciseList: any;
  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  showMoment = false;

  abilityConfig: AbilityConfig;
  //进入新能力考核标识
  version = 0;
  //学习 metaId
  learningPathMetaId: number;
  //学习meta 列表
  moments: any;
  learningPathMetas: any;
  goPostSurveyFlag: boolean;
  isOpenClass = 0;
  isShowQuestionnaire = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;
  exerciseMetaId: any;
  userId: any;
  cardId: any;
  approachTheme: any = {};
  currentIndex = 0;
  isShowApproach = false;
  isCustomLock = false;
  type: string; //是否为pc横版

  projectId: string;
  lock = false;
  isShowToast = false;
  promptText: string;
  isTencent = false; //是否为腾讯对接
  get showGoToSurveyBtn(): boolean {
    if (Array.isArray(this.practiceList)) {
      return this.practiceList.every(item => {
        return item.status === 2;
      });
    }

  }

  constructor(
    private commonService: CommonService,
    private platformLocation: PlatformLocation,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private router: Router
  ) {
  }

  ngOnInit() {
    // if(!localStorage.getItem('openClass')){
    //   this.isOpenClass = this.platformLocation['location']['href'].indexOf('isShowBack') > -1 ? 1: 0;
    //   localStorage.setItem('openClass',String(this.isOpenClass));
    // }else{
    //   this.isOpenClass = Number(localStorage.getItem('openClass'));
    // }
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🍕🍕🍕🍕🍕🍕');
    // -------------------------------------------------------------------
    localStorage.setItem('moduleId', '3');
    this.route.params.subscribe(params => {
      const isOutLink = Number(params['isOutLink']);
      if (this.platformLocation['location']['href'].indexOf('isShowBack') !== -1 || isOutLink === 1){
        localStorage.setItem('openClass', '1');
      }else{
        localStorage.removeItem('openClass');
      }
      this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    });

    this.route.queryParams.subscribe(queryParams => {
      this.type = queryParams['type'];
    });

    this.projectId = localStorage.getItem('projectId');
    const projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
    if (this.projectId && projectmsg){
      projectmsg.map(item => {
        if (item.type == 4 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`;
        }
      });

    }

    this.getPracticeList();
  }

  //获取进度
  getProgress(learningPathMetaId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
    }).toPromise();
  }

  getPracticeList() {
    this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
    this.route.params.subscribe(async (params) => {
      this.exerciseMetaId = params['exerciseMetaId'];
      const LearningTour = await this.getLearningTour();
      this.learningPathMetas = LearningTour.learning_path_metas;
      this.userId = LearningTour.user_id;
      this.exerciseList = await this.createAndGetPracticeList(this.exerciseMetaId, this.userId);
      this.exerciseList.exercise = this.exerciseList.exercise.map((item) => { //循环查询情景模拟阶段数据
        this.getSimulationPhase(item.exerciseMetaId).then(res => {
          item.phaseNum = res ? res.length : 0;
        });
        return item;
      });
      const LearningPathMetaId = await this.getLearningPathMetaId(this.exerciseList.learningPathId);
      this.learningPathMetaId = LearningPathMetaId.data;
      this.learningPath = await this.commonService.getCustomLockDate(this.learningPathMetaId);
      await this.getlearningInit(this.exerciseList.practiceMetaId, this.exerciseList.exercise);
      await this.getListItemExtends(this.exerciseList.exercise);
      const progerss = await this.getProgress(this.learningPathMetaId);
      //向LMS传递进度
      if (localStorage.getItem('source_env') === 'LMS_SCORM'){
        this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', progerss[0].progressList[0].progress, 'data');
      }
      this.currentIndex = progerss[0]['progressList'][0]['currentItemIndex'] == 4 && progerss[0]['progressList'][0]['progress'] == 100 ? 5 : progerss[0]['progressList'][0]['currentItemIndex'];
      this.moments = await this.getPracticeMoments(this.exerciseMetaId, this.userId);

      $('#userIdContainer').val(this.userId);
      $('#learningPathMetaIdContainer').val(this.learningPathMetaId);
      this.learningPathId = this.exerciseList.learningPathId;
      this.practiceList = this.exerciseList.exercise;
      this.practiceId = this.exerciseList.id;
      this.approachTheme.colorSystem = 'dark';
      this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
      this.approachTheme.currentIndex = this.currentIndex - 2;
      this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
      this.approachTheme.btnTxt = '开启能力考核';
      this.practiceList[0].momentsList = this.handleMomentsList(this.moments);

      //增加学习断点
      await this.commonService.addUserBreakPoint({'learningPathMetasId': Number(this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': this.platformLocation['location']['href'], 'projectId': localStorage.getItem('projectId') ? localStorage.getItem('projectId') : null}).then();
      this.commonService.setCustomLockDate(this.learningPath, Date());
      this.isCustomLock = this.learningPath.subItems[3].isLock;
      this.isShowApproach = true;

    });
  }

  linkToError(status) {
    const link = ['error', status];
    this.router.navigate(link);
  }

  createAndGetPracticeList(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet?userId=' + userId
    }).toPromise();
  }

  getPracticeMoments(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list?userId=' + userId
    }).toPromise();
  }

  //获取learningpathid
  getLearningPathMetaId(learningPathId) {
    return this.apiService.ajax({
      'type': 'get',
      // 'url': this.commonService.getOrigin() + '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
      'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
    }).toPromise();
  }

  getCardIdWithUserId(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/currentCard',
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/currentCard?userId=' + userId
    }).toPromise();
  }

  //获取情景模拟的阶段数
  getSimulationPhase(simulationId){
    return this.apiService.ajax({
      'type': 'get',
      'url': `/sim/v1/simulation/${simulationId}/phase_config`
    }).toPromise();
  }

  handleMomentsList(moments) {
    const arr = [];
    if (moments) {
      moments.forEach((v) => {
        arr.push('moments' + v.yySimulationAchievementMeta.exerciseMetaId + '-' + v.yySimulationAchievementMeta.id);
      });
    }
    return arr;
  }

  getlearningInit(practiceMetaId, practiceList) {
    let temp = true;
    this.abilityConfig.getOnceinoByPracticeMetaId(practiceMetaId).subscribe(result => {
      this.finishStatus = result == 1 ? true : false;
      for (let i = 0; i <= practiceList.length - 1; i++) {
        if (practiceList[i].status != 2) {
          temp = false;
        }
      }
      this.finished = temp;
      this.getUserLearningPathMetaId();
    });
  }

  getListItemExtends(practiceList) {
    //loadconfig
    this.apiService
      .loadConfig('./assets/config/practiceList.json')
      .subscribe((result) => {
        practiceList.forEach(function (item, index) {
          console.log(result[item.title]);
          if (result[item.title]) {
            item['extends'] = result[item.title];
          }
        });
      });
  }

  getLearningTour() {
    return this.apiService.ajax({
      type: 'get',
      url: '/sr/learningtournew'
    }).toPromise();
  }

  //获取用户学习 metaid and version
  getUserLearningPathMetaId() {
    const that = this;
    that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(result => {
      that.learningPath = result;
      that.learningPathSubItems = result.subItems;
      if (result.lock !== 3) {
        that.goPostSurveyFlag = true;
      } else {
        that.goPostSurveyFlag = false;
      }
    }).then(() => {
      return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(result => {
        return that.questionnaireInfo = result;
      });
    }).then(() => {
      console.log(that.isShowQuestionnaire);
      that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPathSubItems.filter(d => d.type === 3)[0].progress === 100 && that.learningPathSubItems.filter(d => d.type === 4)[0].progress !== 100;
    });
  }

  getOrCreateLearningPath(learningPathMetaId) {
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: 'white',
    });
  }

  goToNextStep(practiceItem) {
    if (this.learningPathMetaId) {
      const channel = document.getElementById('resource_route');
      const origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
      const params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
      let href = '';
      if (this.learningPathMetaId === 201){//标准版目标选材路由和其他有区别
        href = origin + '/simulation_cn/' + this.exerciseMetaId + '/index.html?learningPathMetaId=' + this.learningPathMetaId + '&exerciseMetaId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
      }else{
        href = origin + '/simulation/' + this.exerciseMetaId + '/index.html?learningPathMetaId=' + this.learningPathMetaId + '&exerciseMetaId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
      }
      this.platformLocation['location']['href'] = this.isOpenClass === 1 ?  href + '&isShowBack=0' : this.type === 'huatek' ? href + '&type=huatek' : href + params;
    } else {
      this.getLearningPathMetaId(this.learningPathId).then(() => {
        this.goToNextStep(practiceItem);
      });
    }
  }

  //展示难忘瞬间gallary
  momentView(mlist, $event) {
    this.showMoment = true;
    this.momentList = mlist;
    $event.stopPropagation();
  }

  //关闭难忘瞬间gallary
  momentExit() {
    this.showMoment = false;
  }

  goToPostSurvey() {
    if ( this.type === 'huatek' ){
      this.commonService.sendPostMessage(1, 'goPostSurvey');
      return;
    }else{
      if (this.lock){
        this.showToast();
        return;
      }

      this.apiService
        .ajax({
          type: 'GET',
          url:
            '/sr/exposeoutapi/setAbilitySession/' +
            this.learningPathMetaId +
            '/4',
        })
        .subscribe((result) => {
        });
      this.commonService.learningPortEventLogByCandy({'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem('userId')}).then();
      const link = ['ability-survey', this.learningPathMetaId, 2];
      this.router.navigate(link);
    }

  }

  showToast(){
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      this.abilityConfig
        .setOnceinoByPracticeMetaId(this.practiceMetaId)
        .subscribe();

      const link = ['learning-map'];
      this.router.navigate(link);
    }
  }

  close() {
    const link = ['learning-path', this.learningPathMetaId];
    this.router.navigate(link);
  }

  closeQuestionnaire() {
    this.isShowQuestionnaire = false;
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-executive-list/case-practice-executive-list.component.ts